var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"program-wrapper link-block",attrs:{"to":{ name: 'program-detail', params: { slug: _vm.data.slug } }}},[_c('img',{attrs:{"src":`${_vm.data.img || ''}`,"alt":"Image"}}),_c('div',{staticClass:"program-content"},[_c('p',{staticClass:"program-summary"},[_vm._v(" "+_vm._s(_vm.data.desc_short || '')+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }